import { defineStore } from 'pinia';
import type { ToastContent, ToastItem, ToastOptions } from '@/types/components/toast';

let toastIdCounter = 0;

export const useToastStore = defineStore('toast', {
    state: () => ({
        toasts: [] as ToastItem[]
    }),

    actions: {
        show(contents: ToastContent = {}, options: ToastOptions = {}) {
            const { duration = 3000, type = 'success' } = options;
            const { message = '' } = contents;

            const toastId = ++toastIdCounter;

            const newToast: ToastItem = {
                id: toastId,
                message,
                type
            };

            this.toasts.push(newToast);

            setTimeout(() => {
                this.hide(toastId);
            }, duration);
        },

        hide(toastId: number) {
            const index = this.toasts.findIndex(t => t.id === toastId);
            if (index !== -1) this.toasts.splice(index, 1);
        },

        hideAll() {
            this.toasts = [];
        }
    }
});
